import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPasswordRecoverySent = loadable(
  () => import('./PasswordRecoverySent'),
  {
    fallback: <Loader />,
  },
);
